import React from 'react';

export default function AnnualReportsSection({ annualReports = [] }) {
  if (!annualReports || annualReports.length === 0) {
    return null;
  }

  return (
    <section id="annual-reports" className="annual-reports-section">
      <div className="container">
        <div className="section-header">
          <h2>Annual Reports</h2>
          <p className="section-subtitle">Transparency in Our Impact</p>
        </div>
        
        <div className="reports-grid">
          {annualReports.map((report) => (
            <div className="report-card" key={report.id}>
              <div className="report-thumbnail">
                {report.thumbnail ? (
                  <img src={report.thumbnail} alt={report.title} />
                ) : (
                  <div className="report-placeholder">
                    <i className="fas fa-file-pdf"></i>
                    <span>{report.year}</span>
                  </div>
                )}
              </div>
              <div className="report-content">
                <h3>{report.title}</h3>
                <p className="report-year">{report.year}</p>
                {report.pdfUrl ? (
                  <a 
                    href={report.pdfUrl} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="btn btn-report"
                  >
                    <i className="fas fa-download"></i> Download Report
                  </a>
                ) : (
                  <span className="report-coming-soon">Coming Soon</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
